import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
// import {formatDate, getMonthName, formatDateDisplay} from '../src/utils/formatDate';
// Retrieve saved language from localStorage or default to English
const savedLanguage = localStorage.getItem("i18nextLng") || "en";

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: savedLanguage, // Set the saved language
    fallbackLng: "en",
    supportedLngs: ["en", "mm"],
    debug: process.env.NODE_ENV === "development",
    interpolation: {
      escapeValue: false,
      // // Add to the format function in interpolation
      // format: (value, format, lng) => {
      //   if (format === 'date') {
      //     return formatDate(value, lng);
      //   }
      //   if (format === 'number' && lng === 'mm') {
      //     const nums = ['၀','၁','၂','၃','၄','၅','၆','၇','၈','၉'];
      //     return value.toString().replace(/[0-9]/g, (d) => nums[d]);
      //   }
      //   return value;
      // }
    },
    ns: ["translation"],
    defaultNS: "translation",
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
    saveMissing: true,
  });

export default i18n;